<template>
  <div class="page page-legals">
    <Header />
    
    <template v-if="this.data?.sections">
      <component
        v-for="(section, i) in this.data?.sections"
        :key="i"
        :is="section.blocName"
        :content="section"
      ></component>
    </template>

    <GridHelper />
  </div>
</template>

<script>
import Data from '@/data' 

import GridHelper from '@/components/GridHelper.vue'
import Header from '@/components/Header.vue'
import TextSimple from '@/components/TextSimple.vue'

export default {
  name: 'Legals',
  components: {
    Header,
    TextSimple,
    GridHelper
  },
  data () {
    return {
        data: Data['legals'],
    }
  }
}
</script>

